import { render, staticRenderFns } from "./LogsHistoryItemSR.vue?vue&type=template&id=44b64b7f&scoped=true"
import script from "./LogsHistoryItemSR.vue?vue&type=script&lang=js"
export * from "./LogsHistoryItemSR.vue?vue&type=script&lang=js"
import style0 from "./LogsHistoryItemSR.vue?vue&type=style&index=0&id=44b64b7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b64b7f",
  null
  
)

export default component.exports